var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',_vm._l((_vm.page.modules),function(module,i){return _c('v-container',{key:i,attrs:{"py-0":"","mt-5":""}},[_c('ComponentLoader',{attrs:{"componentType":module.type,"options":module.data}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }